export default __webpack_public_path__ + "static/media/grafema_SET_01.7027a1a7.mp4";